<div class="row mt-3">
  <div class="col text-center" *ngIf="isReady">
    <lib-radio-buttons [underLine]="true" [value]="value" [list]="inputList" (valueChange)="setLendingType($event)"></lib-radio-buttons>
  </div>
</div>
